/** Fórmula de contraste WCAG 2.1, a mesma do gate `lume-contrast.test.ts` (U16). */
export type Rgba = readonly [number, number, number, number];

export function parseColor(value: string): Rgba {
  const hex = /^#([0-9a-f]{3,8})$/i.exec(value.trim());
  if (hex) {
    let h = hex[1] ?? '';
    if (h.length === 3 || h.length === 4) h = h.replace(/./g, (c) => c + c);
    if (h.length !== 6 && h.length !== 8) throw new Error(`cor não suportada: ${value}`);
    const n = Number.parseInt(h.slice(0, 6), 16);
    const a = h.length === 8 ? Number.parseInt(h.slice(6), 16) / 255 : 1;
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255, a];
  }
  const rgb = /^rgb\((\d+) (\d+) (\d+)(?: \/ ([\d.]+))?\)$/.exec(value.trim());
  if (rgb) return [Number(rgb[1]), Number(rgb[2]), Number(rgb[3]), Number(rgb[4] ?? 1)];
  throw new Error(`cor não suportada: ${value}`);
}

export function over(top: Rgba, bottom: Rgba): Rgba {
  const a = top[3];
  return [top[0] * a + bottom[0] * (1 - a), top[1] * a + bottom[1] * (1 - a), top[2] * a + bottom[2] * (1 - a), 1];
}

export function luminance([r, g, b]: Rgba): number {
  const channel = (c: number) => {
    const s = c / 255;
    return s <= 0.04045 ? s / 12.92 : ((s + 0.055) / 1.055) ** 2.4;
  };
  return 0.2126 * channel(r) + 0.7152 * channel(g) + 0.0722 * channel(b);
}

/** Contraste entre tinta e fundo; ambos podem ter alfa (compostos sobre `base`). */
export function contrast(ink: string, ground: string, base = '#ffffff'): number {
  const g = over(parseColor(ground), parseColor(base));
  const i = over(parseColor(ink), g);
  const a = luminance(i);
  const b = luminance(g);
  return (Math.max(a, b) + 0.05) / (Math.min(a, b) + 0.05);
}
